<template>

    <div id="login-window">

        <h1 class="text-center">Kasse</h1>

        <b-form @submit="onSubmit" class="mb-3">
            <b-form-group >
                <b-form-input type="text" name="username" v-model="form.username" placeholder="Brukernavn" trim/>
            </b-form-group>
            <b-form-group   >
                <b-form-input type="password" name="password" v-model="form.password" placeholder="Passord" trim/>
            </b-form-group>

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <b-button type="submit" variant="primary">Kjør på!</b-button>
        </b-form>


    </div>

</template>

<script>

export default {
    name: 'LoginWindow',
    data() {
        return {
            form: {
                username: process.env.VUE_APP_TEST_USERNAME ? process.env.VUE_APP_TEST_USERNAME : '',
                password: process.env.VUE_APP_TEST_PASSWORD ? process.env.VUE_APP_TEST_PASSWORD : '',
            },
            errors: [],
            messages: {
                register: false,
            }
        }

    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()

            // Validation
            this.errors = []
            this.messages.register = false;

            if (!this.form.username) this.errors.push('Brukernavn mangler.')
            if (!this.form.password) this.errors.push('Passord mangler.')


            if (this.errors.length == 0) {

                this.loginUser();

            }
        },
        loginUser() {
            this.$api.post('/login', {}, {
                auth: {
                    username: this.form.username,
                    password: this.form.password
                }
            })
            .then((response) => {
                this.$store.setToken(response.data.token);
                this.$store.setUser(response.data.user)

                this.$api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;


                this.$router.replace('/');
            })
            .catch((error) => {

                if (error.response) {
                    let code = error.response.status;

                    if (code == 401) {
                        this.errors.push('Du har tastet inn feil brukernavn eller passord.')
                    }
                    else if (code == 404) {
                        this.$emit("register",this.form)
                    }
                    else {
                        this.errors.push('En feil har oppstått. Kontakt magikerne.')
                    }
                }
                else {
                    this.errors.push('En feil har oppstått. Kontakt magikerne.')
                }
            });

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

h1 {
    margin-bottom: 1em;
}

.login .errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

.login .logo {
    max-width: 100px;
    margin-bottom: 2em;
}

</style>
